// Страница незавершённых упражнений студента: список упражнений с незавершённым статусом.

import { useNavigate } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import AppNavbar from '../../components/common/AppNavbar';
import IncompleteExerciseList from '../../components/students/history/IncompleteExerciseList';

export default function StudentIncompleteExercisesPage() {
  const navigate = useNavigate();

  return (
    <>
      <AppNavbar />
      <div style={{ background: 'var(--ewl-bg-body)', minHeight: 'calc(100vh - 56px)' }}>
        <Container className="py-4" style={{ maxWidth: 760 }}>

          {/* Кнопка назад */}
          <div className="mb-2">
            <Button
              variant="link"
              size="sm"
              onClick={() => navigate('/student')}
              style={{
                padding: 0,
                color: '#6c757d',
                textDecoration: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
              }}
            >
              ← К панели студента
            </Button>
          </div>

          {/* Заголовок */}
          <div className="mb-4">
            <h5
              className="fw-bold mb-1"
              style={{ color: '#1e2a4a', letterSpacing: '-0.01em' }}
            >
              Незавершённые упражнения
            </h5>
            <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
              Продолжите выполнение начатых упражнений и улучшите свои результаты
            </p>
          </div>

          {/* Список */}
          <IncompleteExerciseList />

        </Container>
      </div>
    </>
  );
}
